<drawer
    [id]="'app-sidebar'"
    [position]="'left'"
    [isVisible]="true"
    [showCloseIcon]="false"
    [closeOnEscape]="false"
    [styleClass]="isCollapsed() ? 'app-sidebar collapsed' : 'app-sidebar expanded'"
    [modal]="false">
    <div id="sidebar-header" customHeader>
        <a [routerLink]="appRoutes.BASE" aria-label="Go to Dashboard">
            <img
                [ngSrc]="'images/app-logo.svg'"
                [id]="'app-logo-sidebar'"
                [alt]="'The application logo and redirects to the dashboard'"
                [height]="40"
                [width]="40" />
        </a>
        <div [ngClass]="isCollapsed() ? 'hidden' : 'displayed'">
            <h1 id="app-title">Colony + AMI</h1>
            <h2 id="app-subtitle">Transnetyx</h2>
        </div>
    </div>

    <div id="sidebar-content">
        <app-navigation [isSidebarCollapsed]="isCollapsed()" (toggleIsCollapsed)="toggleIsCollapsed()"></app-navigation>
    </div>

    <div
        [id]="'collapse-area'"
        [ngClass]="isCollapsed() ? 'collapse-area-c' : 'collapse-area-e'"
        (click)="toggleIsCollapsed()">
        <i class="fa-thin fa-angle-right" [class.collapsed]="isCollapsed()" [class.expanded]="!isCollapsed()"></i>
    </div>
</drawer>
